export default "__VITE_ASSET__A6uUMZF5__"